module.exports = __webpack_public_path__ + "img/17.47281aa0.jpg";